export default "__VITE_ASSET__GQ0y8Pdt__"